/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

/**
 * Projects State
 *
 * @type {Object}
 */
const base = {
    loaded: false,
    pending: false,
    data: [],
    meta: {},
    cardLayout: true
}

/**
 * Return a fresh copy of the base state
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(base)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/projects/state.js